import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { UiShowcaseRoutingModule } from './ui-showcase-routing.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { FormsModule } from '@angular/forms';
import { UiShowcaseComponent } from './main/ui-showcase.component';
import { LayoutModule } from '../../components/cleanui/layout/layout.module';
import { ModalShowcaseComponent } from './modal-showcase/modal-showcase.component';
import { ButtonShowcaseComponent } from './button-showcase/button-showcase.component';
import { FeatherModule } from 'angular-feather';
import { ElementsModule } from '../../components/elements/elements.module';
import { FormularShowcaseComponent } from './formular-showcase/formular-showcase.component';
import { JsonSchemaRendererModule } from '../../components/renderer/json-schema-renderer.modul';
import { TableShowcaseComponent } from './table-showcase/table-showcase.component';
import { WorkflowDetailShowcaseComponent } from './workflow-detail-showcase/workflow-detail-showcase.component';
import { OverviewTileShowcaseComponent } from './overview-tile-showcase/overview-tile-showcase.component';
import { WorkflowModule } from '../../workflow/workflow.module';
import { ButtonFunctionShowcaseComponent } from './button-function-showcase/button-function-showcase.component';
import { MarkdownModule } from 'ngx-markdown';
import { DistractionFreeWizardShowcaseComponent } from './distraction-free-wizard-showcase/distraction-free-wizard-showcase.component';
import { IconShowcaseComponent } from './icon-showcase/icon-showcase.component';
import { AudioShowcaseComponent } from '@app/pages/ui-showcase/audio-showcase/audio-showcase.component';
import { ButtonsWfsStatusComponent } from '@app/pages/ui-showcase/buttons-wfs-status/buttons-wfs-status.component';
import { TimelineShowcaseComponent } from './timeline-showcase/timeline-showcase.component';


// dashboard

const COMPONENTS = [
	ButtonFunctionShowcaseComponent,
	ButtonShowcaseComponent,
	DistractionFreeWizardShowcaseComponent,
	FormularShowcaseComponent,
	ModalShowcaseComponent,
	OverviewTileShowcaseComponent,
	TableShowcaseComponent,
	UiShowcaseComponent,
	WorkflowDetailShowcaseComponent,
	OverviewTileShowcaseComponent,
	IconShowcaseComponent,
	AudioShowcaseComponent,
	ButtonsWfsStatusComponent,
];

@NgModule({
	imports: [
		ElementsModule,
		FeatherModule,
		FormsModule,
		JsonSchemaRendererModule,
		LayoutModule,
		MarkdownModule,
		SharedModule,
		UiShowcaseRoutingModule,
		WidgetsComponentsModule,
		WorkflowModule,
	],
	declarations: [...COMPONENTS, TimelineShowcaseComponent],
})
export class UiShowcaseModule {}
